module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "sgc-1",
    attrs: {
      "id": "failureofjustice-kindleinterior-5-8-2016"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "calibre1",
    attrs: {
      "id": "tc-101"
    }
  }, [_c('div', {
    staticClass: "calibre1"
  }, [_c('p', {
    staticClass: "normal-242-0-override"
  }, [_c('span', {
    staticClass: "no-style-override1"
  }, [_c('br', {
    staticClass: "calibre1"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "calibre1"
  }, [_c('p', {
    staticClass: "chapter-247-0-override",
    attrs: {
      "id": "toc-anchor-40"
    }
  }, [_c('span', {
    staticClass: "no-style-override5"
  }, [_vm._v("ACKNOWLEDGMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override1"
  }, [_c('br', {
    staticClass: "calibre1"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override1"
  }, [_vm._v("I would be remiss if I didn’t take the time to single out a number of people who went above and beyond the call of duty in helping me produce")]), _vm._v(" "), _c('span', {
    staticClass: "no-style-override"
  }, [_vm._v("Failure of Justice")]), _c('span', {
    staticClass: "no-style-override1"
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override1"
  }, [_vm._v("First, my publisher, WildBlue Press, led by co-founders Steve Jackson and Michael Cordova. This marks my third book with WildBlue Press, and I have been incredibly fortunate to have gotten to know Steve and Michael and many other fine members of the WildBlue Press team over these past few years. Along those lines, I must single out my copy editor Mary Kay Wayman for her strong attention to detail. Mary Kay had a profound impact on shaping and editing the content and the story flow of")]), _vm._v(" "), _c('span', {
    staticClass: "no-style-override"
  }, [_vm._v("Failure of Justice,")]), _vm._v(" "), _c('span', {
    staticClass: "no-style-override1"
  }, [_vm._v("and for that I am especially grateful. Additional recognition goes out to WildBlue Press designer Elijah Toten for coming up with an excellent book cover. I also want to thank Ashley Butler, who leads the WildBlue Press communications team and works hard to promote the content of all the WildBlue Press authors.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override1"
  }, [_vm._v("I would also like to thank my wife, Andrea, and our three children, Libby, JD and Caroline, for being overly supportive in letting me pursue my passion of writing nonfiction. Without your strength and encouragement, I would be nowhere.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override1"
  }, [_vm._v("I have worked on writing")]), _vm._v(" "), _c('span', {
    staticClass: "no-style-override"
  }, [_vm._v("Failure of Justice")]), _vm._v(" "), _c('span', {
    staticClass: "no-style-override1"
  }, [_vm._v("for more than two years, first taking up the project in January of 2014. Along the way, I’ve reviewed somewhere in the neighborhood of 10,000 court-related documents, police reports, plus countless newspaper articles that date back to 1985. ")])])]), _vm._v(" "), _c('div', {
    staticClass: "calibre1"
  }, [_c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override1"
  }, [_vm._v("I feel indebted to a number of people who were helpful and gracious with their time as I tried to make this book project possible:")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override1"
  }, [_vm._v("Tina Vath, a police investigator from Beatrice; Randy Ritnour, a former Gage County prosecutor; Pete Klismet, retired FBI special agent; Beatrice Police Chief Bruce Lang; Beatrice Police Lieutenant Mike Oliver; Ernie Chambers, an Omaha state senator; Jon Bruning, former Nebraska attorney general; Artis Milke, an employee at the Beatrice Library; Scottsbluff lawyer Maren Chaloupka; Nebraska author Merle Henkenius; Lincoln attorneys Herb Friedman and Toney Redman; Gage County District Judge Paul Korslund; and Beatrice attorney Lyle Koenig.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override1"
  }, [_vm._v("Additionally, a special word of thanks also goes out to members of the Helen Wilson family, particularly Helen’s daughter-in-law Edie Wilson and Helen’s granddaughter Jan Grabouski. They both helped me better understand the life of Helen Wilson.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override1"
  }, [_vm._v("I also want to thank the")]), _vm._v(" "), _c('span', {
    staticClass: "no-style-override"
  }, [_vm._v("Lincoln Journal Star")]), _vm._v(" "), _c('span', {
    staticClass: "no-style-override1"
  }, [_vm._v("for granting me permission to republish a handful of photos and also to")]), _vm._v(" "), _c('span', {
    staticClass: "no-style-override"
  }, [_vm._v("Beatrice Daily Sun")]), _vm._v(" "), _c('span', {
    staticClass: "no-style-override1"
  }, [_vm._v("editor Patrick Ethridge for his help as well. Both newspapers did an exceptional job over the past many years in covering the many twists and turns that arose during the Wilson murder case, a tragedy like no other in Nebraska.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override1"
  }, [_vm._v("Most of the quotations that appear throughout")]), _vm._v(" "), _c('span', {
    staticClass: "no-style-override"
  }, [_vm._v("Failure of Justice")]), _vm._v(" "), _c('span', {
    staticClass: "no-style-override1"
  }, [_vm._v("come from court testimony, police reports, lawsuit depositions, written statements about the case provided directly to me, numerous interviews I’ve conducted, newspapers articles, press conference speeches, minutes of state legislative hearings.")])])]), _vm._v(" "), _c('div', {
    staticClass: "calibre1"
  }, [_c('p', {
    staticClass: "normal-242-0-override"
  }, [_c('span', {
    staticClass: "no-style-override1"
  }, [_vm._v("***")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override1"
  }, [_c('br', {
    staticClass: "calibre1"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "normal-242-0-override"
  }, [_c('span', {
    staticClass: "no-style-override"
  }, [_vm._v("Failure of Justice")]), _vm._v(" "), _c('span', {
    staticClass: "no-style-override1"
  }, [_vm._v("is dedicated to public defender Jerry Soucie, a true crusader for Nebraska’s wrongly condemned."), _c('br', {
    staticClass: "calibre1"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2",
    attrs: {
      "id": "calibre_pb_18"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e788f10","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/part0005.vue
// module id = 75
// module chunks = 0